export interface Ready {
	type: "ready";
}

export const readyMessage = (): Ready => ({
	type: "ready"
});
